import { ReplaySubject } from 'rxjs';
import { finalize, filter } from 'rxjs/operators';

import { PusherService } from '../../services/pusher-service';

const _findMessage = ({ cache$, filterFunc }) => {
  return cache$.pipe(filter(filterFunc));
};

export const createPusherMessageCache = (eventKeys, fallbackOptions) => {
  const cache$ = new ReplaySubject();

  // below handles the original implementation case where a single key was passed instead of an array
  const keysToBind = Array.isArray(eventKeys) ? eventKeys : [eventKeys];

  const onMessage = (msg) => {
    return cache$.next(msg);
  };

  const allUnbindFromEvent = keysToBind.map((eventKey) => {
    return PusherService.bindToEvent(eventKey, onMessage, undefined, fallbackOptions);
  });

  return {
    findMessage: (messageCheckerFunc) => {
      return _findMessage({
        cache$: cache$.pipe(
          finalize(() => {
            allUnbindFromEvent.forEach((unbindFromEvent) => {
              unbindFromEvent();
            });
          }),
        ),
        filterFunc: messageCheckerFunc,
      });
    },
  };
};
